"use client"

import { useState } from "react"
import { createPortal } from "react-dom"
import { addItemToCart, removeItemFromCart, useCartState } from "src/checkout/hooks/useCart"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import { NpRadioButton } from "src/components/np-design/components/input/NpRadioButton"
import { NpAccessoryDetailsModal } from "src/components/np-design/sections/cart-sidebar/NpAccessoryDetailsModal"
import { ProductListItemImage } from "src/components/product-list/ProductListItemImage"
import { BusyIndicator } from "src/components/unstyled/BusyIndicator"
import { ResolvedAccessoryProductData } from "src/data/product-accessories-resolved/types"
import { formatPriceLong } from "src/utilities/price"

export type NpAccessoryProps = {
  accessory: ResolvedAccessoryProductData
}

export const NpAccessory = ({ accessory }: NpAccessoryProps) => {
  const { data: cart } = useCartState()
  const [updating, setUpdating] = useState(false)
  const [showDetails, setShowDetails] = useState(false)

  const cartItem = cart?.items.find((item) => item.product.slug === accessory.slug)

  return (
    <div className="flex w-30 flex-col items-center text-center">
      <NpButton
        iconNameLeft="info_outline"
        variant="ghost"
        color="gray75"
        size="md"
        title="Details"
        onClick={() => setShowDetails(true)}
      />

      {showDetails &&
        createPortal(
          <NpAccessoryDetailsModal accessory={accessory} onClose={() => setShowDetails(false)} />,
          document.body,
        )}

      <ProductListItemImage src={accessory.images[0]!} alt={accessory.name} className="size-30" />

      <div className="flex flex-col items-center gap-4">
        <div className="font-product line-clamp-3 h-15">{accessory.name}</div>

        {cartItem ? <div className="font-product">hinzugefügt</div> : <div>{formatPriceLong(accessory.price)}</div>}

        {updating ? (
          <div className="flex size-10 items-center justify-center">
            <BusyIndicator />
          </div>
        ) : (
          <NpRadioButton
            variant="add"
            as="button"
            active={!!cartItem}
            onClick={async () => {
              setUpdating(true)

              if (cartItem) {
                await removeItemFromCart(cartItem.key)
              } else {
                await addItemToCart(accessory.id)
              }

              setUpdating(false)
            }}
          />
        )}
      </div>
    </div>
  )
}
